<template>
    <div>
        <div class="seachBox flex" style="justify-content: flex-start;">
            <div class="seachList"><span class="name">客户名称：</span>
                <a-select
                        placeholder="请输入客户名称"
                        v-model="product_id" class="seachs"
                        :default-active-first-option="false"
                        :filter-option="false"
                        :not-found-content="null"
                        :options="options"
                        :show-arrow="false"
                        show-search
                        @change="handleChange"
                        @search="handleSearch"
                >
                </a-select>
            </div>
            <div class="seachList"><span class="name">导入类型：</span>
                <a-select v-model="importType" class="seachs" allowClear placeholder="请选择">
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in dataList.types">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div style="margin: 5px 0;">   
                <a-button @click="importFun" type="primary" size="default" class="seachBtn" style="margin-right: 15px">
                    导入
                </a-button>
            </div>
            <p style="margin: 11px 0;font-size: 14px;line-height: 20px;color: #f5222d;">提示：老用户导入类型不可选择‘全部’，否则可能会导入出错，影响客户数据。</p>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>
        <a-table :columns="columns"  :data-source="data" :loading="loading" :pagination="false" rowKey="id"  v-if="data.length>0">
        </a-table>
        <a-empty v-else  :description="description" />
        <importModel v-if="visibleImport" @changVisible="changVisible" :templateCode="templateCode" :product_ids="product_id" :importType="importType" :visible="visibleImport" :dataList="dataList"></importModel>
        <div v-if="product_id">
            <div class="title">导入日志</div>
            <div class="seachBox flex">
                <div class="seachList"><span class="name">导入类型：</span>
                    <a-select v-model="searchForm.type" class="seachs" allowClear placeholder="请选择">
                        <a-select-option :value="item.id" :key="index" v-for="(item,index) in dataList.types">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="seachList"><span class="name">状态：</span>
                    <a-select v-model="searchForm.status" class="seachs" allowClear  placeholder="请选择">
                        <a-select-option :value="1" >
                            导入成功
                        </a-select-option>
                        <a-select-option :value="2" >
                            导入失败
                        </a-select-option>
                      <a-select-option :value="4" >
                        导入已取消
                      </a-select-option>
                    </a-select>
                </div>
                <div class="seachList  ">
                    <a-button @click="searchFun" type="primary" size="default" class="seachBtn" style="margin-right: 15px">
                        查询
                    </a-button>
                </div>
                <div class="seachList no"></div>
                <div class="seachList no"></div>
                <div class="seachList no"></div>
            </div>
            <a-table :columns="logColumns" :data-source="logData" :pagination="pagination" rowKey="id" :loading="loadingtable"
                      v-if="data.length>0">
                <template slot="operate" slot-scope="text, record" >
                    <span class="text-err"  @click="openErr(record.file_url)" v-if="record.file_url!=''">错误报告</span>
                    <span class="text-err"  @click="cancelImport(record.id)" v-if="record.status=='导入中'">取消导入</span>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
    import API from "./api";
    import importModel from "./components/importModel"
    import {changStatus, removeById, orderList, debounce} from "../../../utils/utils"
    const columns = [
        {
            title: "客户名称",
            dataIndex: "company",
            ellipsis: true,
            key: "company",
        },
        {
            title: "手机号",
            dataIndex: "mobile",
            ellipsis: true,
            key: "mobile",
          scopedSlots: {customRender: "mobile"}
        },
        {
            title: "网址",
            dataIndex: "domain",
            ellipsis: true,
            key: "domain",scopedSlots: {customRender: "domain"}
        },
    ];
    const logColumns = [
        {
            title: "导入类型",
            dataIndex: "type",
            ellipsis: true,
            key: "type",
        },
        {
            title: "导入内容",
            dataIndex: "method",
            ellipsis: true,
            key: "method",
            scopedSlots: {customRender: "method"}
        },
        {
            title: "导入时间",
            dataIndex: "create_time",
            ellipsis: true,
            key: "create_time",scopedSlots: {customRender: "create_time"}
        },
        {
            title: "状态",
            dataIndex: "status",
            ellipsis: true,
            key: "status",scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            dataIndex: "operate",
            ellipsis: true,
            key: "operate",scopedSlots: {customRender: "operate"}
        },
    ];
    export default {
        name: "index",
        components: {importModel},
        data() {
            return {
                logData:[],
                visibleImport:false,
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                tableImg: "",
                importType:'',
              templateCode:'',
                dataList:{},
                searchForm:{
                    type:'',
                    status:'',
                    id:'',
                },
                description:'请先选择客户',

                seachList: {
                    category: [],
                    status: [],
                },
                product_id:'',
                seach: {
                    id: "",

                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                logColumns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: false,
                title: "",
                editId: null,
                options:[],
                page:1
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/BatchImport"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getImport()
        },

        methods: {
            openErr(data){
                console.log(data)
                window.open(data)
            },
            searchFun(){
                this.getList(1)
            },
            importFun(){
                if(this.product_id==''){
                    this.$message.warning('请选择客户');
                }else if(!this.importType){
                    this.$message.warning('请选择导入类型');
                }else{
                    this.visibleImport=true
                }


            },
            changVisible(){
              this.searchFun(1)
                this.visibleImport=false
                this.getList(1)
            },
            // onSelectChange(selectedRowKeys) {
            //     let data = JSON.parse(JSON.stringify([selectedRowKeys[selectedRowKeys.length-1]]))
            //     this.product_ids = data;
            //     console.log(this.product_ids);
            // },
            handleSearch: debounce(function (val)   {
                this.handleSearchFn(val)
            }, 300),
            handleSearchFn(val){
                this.options=[];
                this.seachList.name=[]
                //下拉模糊查询
                if(val){this.getSeachList(val)}
            },
            handleChange(value) {
                console.log("------",value)
                if(value==undefined)return
                this.searchForm.id = value
                this.getUser(value,'1')
                this.getList(1)
            },
            getSeachList(company){
                API.service.GET_LIST({company}).then(res => {
                    this.seachList.name = res.data.data
                    res.data.data.forEach((item) => {
                        this.options.push({
                            value: item.id,
                            label: item.company,
                        })
                    });
                })
            },
            getList(page){
                this.page=page
                this.loadingtable=true
                let seachData = JSON.parse(JSON.stringify(this.searchForm))
                API.service.GET_TABLE_LIST({page: page || this.pageNum, ...seachData}).then(res => {
                    this.pageNum=page || this.pageNum
                    if(res.data.code==400 &&type!="reset"){
                        this.$message.destroy()
                        this.$message.error(res.data.msg)
                        return
                    }
                    if(res.data.data.data ){
                        this.logData = res.data.data.data}else{ this.logData=[]}
                    if(this.data.length>0){
                        this.pagination.total = res.data.data.total
                        this.pagination.pageSize = res.data.data.per_page
                        this.pagination.current = res.data.data.current_page
                    }else{
                        this.description="暂无数据"
                    }
                    this.loadingtable=false
                })
            },

            getUser(data){
                let queryData = {
                    id:data
                }
                API.service.GET_LIST(queryData).then(res=>{
                    console.log("res",res)
                    this.data = [res.data.data]
                    this.templateCode=res.data.data.template_code
                  // res.data.data.template_code
                }).finally(res=>{
                    this.loading=false

                })
            },
            getImport(){
                API.service.GET_IMPORT().then(res=>{
                    this.dataList = res.data.data
                })
            },
            // 取消导入
            cancelImport(id){
                let _this = this
                _this.$confirm({
                    content: "确认取消导入嘛？",
                    icon: "exclamation-circle",
                    type: 'error',
                    onOk() {
                        API.service.IMPORT_CANCEL({
                            id:id
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.getList(_this.page)
                            }
                        })
                    },
                    onCancel() {}
                });
            }
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
    .title{
        font-size: 16px;
        font-weight: 700;
    }
    .text-err{
        color: #0000ff;
        cursor:pointer;
    }
    .text-err+.text-err {
        margin-left: 10px;
    }
</style>
